import { render } from "./receipt-information.vue?vue&type=template&id=f54d2e34&scoped=true"
import script from "./receipt-information.vue?vue&type=script&lang=js"
export * from "./receipt-information.vue?vue&type=script&lang=js"

import "./receipt-information.vue?vue&type=style&index=0&id=f54d2e34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54d2e34"]])

export default __exports__